import { FunctionComponent } from 'react';
import { ArticleModel } from '../../../services/content/article/models/ArticleModel';
import { SectionsDivider } from '../../Section/SectionsDivider';
import { SectionSecondaryContent } from '../../Section/SectionSecondaryContent';

type Props = {
    articles: ArticleModel[];
    title: string;
    backgroundColor: string;
};

export const RelatedNews: FunctionComponent<Props> = ({ articles, title, backgroundColor }) => {
    return (
        <div className='container pb-4 pt-4' style={{ backgroundColor: backgroundColor }}>
            <div className='row'>
                <div className='col-12'>
                    <SectionsDivider title={title} display={true} />
                </div>
            </div>
            <div className='row'>
                {articles.map((article) => {
                    return (
                        <div className='col-12 col-md-3 col-lg-3' key={`related-news-key-${article.id}`}>
                            <SectionSecondaryContent content={article} category={article.category} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
